import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

const VFCDetailsPage = () => {
  const { vfcId } = useParams();
  const [vfc, setVfc] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const LOCAL_KEY = `vfcSummarryData${vfcId}`;

  const saveToLocalCache = (vfcData) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcList: vfcData, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVFCDetails = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(`${Api}/api/vfcs/${vfcId}`, config);
      setVfc(res.data.vfc);
      saveToLocalCache(res.data.vfc);
    } catch (error) {
      console.error("Failed to fetch VFC details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcList) {
      setVfc(cached.vfcList);
      setLoading(false);
    } else {
      fetchVFCDetails();
    }
  }, [vfcId]);

  if (loading) return <Preloader loading={true} />;
  if (!vfc)
    return <p className="text-danger m-5">VFC not found or access denied.</p>;

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString() : "N/A";

  const details = [
    { label: "Circle", value: vfc.circleName },
    { label: "Division", value: vfc.divisionName },
    { label: "Range", value: vfc.rangeId?.rangeName },
    { label: "VFC Code", value: vfc.vfcCode },
    { label: "Location", value: vfc.location },
    { label: "Village", value: vfc.village },
    { label: "Thaluk", value: vfc.thaluk },
    { label: "Panchayath", value: vfc.panchayath },
    { label: "PIN Code", value: vfc.pinCode },
    { label: "Est. Date", value: formatDate(vfc.dateOfEstablishment) },
    { label: "Bank Name", value: vfc.bankName },
    { label: "Branch", value: vfc.branch },
    { label: "IFSC Code", value: vfc.ifscCode },
    { label: "Account Number", value: vfc.accountNumber },
    { label: "Registration No.", value: vfc.registrationNo },
    {
      label: "Total Members",
      value: vfc.totalMembers,
    },
    {
      label: "Male",
      value: vfc.maleCount,
    },
    {
      label: "Female",
      value: vfc.femaleCount,
    },
    {
      label: "Third Gender",
      value: vfc.otherCount,
    },
    { label: "President.", value: "N/A" },
  ];

  return (
    <div>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              localStorage.removeItem(LOCAL_KEY);
              setLoading(true);
              fetchVFCDetails();
            }}
          >
            🔄 Refresh Now
          </button>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="card bg-gradient-MintGreen card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-bold mb-3">VFC - {vfc.vfcName}</h4>
          <h4 className="font-weight-normal mb-3">
            Total Members - {vfc.totalMembers}
          </h4>
        </div>
      </div>
      <div className="col-lg-12 stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  {details.map((item, idx) => (
                    <tr key={idx} className="table-success">
                      <td style={{ fontWeight: "bold", width: "30%" }}>
                        {item.label}
                      </td>

                      <td>{item.value || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VFCDetailsPage;
